const commonTranslation = {
  hello: "Ciao",
  welcome: "Benvenuto",
  english: "Inglese",
  german: "Tedesco",
  italian: "Italiano",
  french: "Francese",
  currentLanguage: "it-IT",
  notAvailable: "N/D",
  close: "Chiudi",
  preview: "Anteprima",
  invoiceDocument: "Documento della fattura",
  zoomIn: "Ingrandisci",
  zoomOut: "Riduci",
  rotateRight: "Ruota a destra",
  rotateLeft: "Ruota a sinistra",
  resetZoom: "Reimposta lo zoom",
  previousPage: "Pagina precedente",
  nextPage: "Pagina successiva",
  showPassword: "Mostra password",
  hidePassword: "Nascondi password",
  qrCode: "Codice QR",
  drag: "Trascina per riordinare",
  clickToRefresh: "Fai clic per aggiornare",
  sampleComponent: "Componente di esempio",
  sidebar: "Barra laterale",
  invalidCredentials: "Credenziali non valide",
  requestFailed: "Impossibile completare la richiesta",
  toast_error: "Errore",
  toast_warning: "Avviso",
  toast_success: "Operazione riuscita",
  toast_info: "Informazione",
  unknownStatus: "Stato sconosciuto",
  unknownLanguage: "Lingua sconosciuta",
  unknownField: "Informazioni aggiuntive"
};

const loginComponent = {
  email: "E-Mail",
  emailAddress: "indirizzo e-mail",
  username: "Nome utente",
  password: "Password",
  login: "Log-in",
  signUp: "Iscriviti",
  multifactorAuthentication: "Autenticazione a più fattori",
  OTPCode: "Codice OTP",
  verifyAndProceed: "Verifica & conferma",
  resendOTP: "Invia nuovamente OTP",
  readMore: "Ulteriori informazioni",
  logout: "Disconnetti",
  loginOrSignup: "Log-in",
  loginWelcome: "Bentornato! Inserisci i tuoi dati.",
  enterEmail: "Inserisci l'e-mail",
  enterPassword: "Password",
  getStarted: "Cominciare!",
  profile: "Profilo",
  assignment_confirmation: "Conferma assegnazione",
  revoke_confirmation:"Revoca assegnazione",
  verificationRequired: "Verifica richiesta",
  verificationDescription: "Inserisci il codice visualizzato nell'app di autenticazione",
  no_content : "Nessun contenuto",
  loginRemember: "Ricordati di me per 24 ore",
  ForgotPassword: "Password dimenticata", 
  NoAccount: "Non hai un account?",
  loginAppInfo: "Non ho accesso alla mia App Authenticator",
  loginSuccess: "Accesso riuscito",
  loginError: "Errore di accesso",
  loginHeroTitle: "Benvenuto in IDP-AI di UpQuAI",
  loginHeroSubtitle: "Dove la tecnologia incontra l'esperienza assicurativa",
};

const dashboardComponent = {
  gridView: "Vista a griglia",
  tableView: "Visualizzazione tabella",
  PDFExtraction: "Pannello di controllo FNOL",
  search: "Ricerca",
  filter: "Filtro",
  filters: "Filtri",
  sortBy: "Ordina per",
  refresh: "Aggiorna",
  sort: "Ordina",
  sortFields: "Campi di ordinamento",
  edit: "Modifica",
  download: "Scarica",
  versionHistory: "Cronologia",
  documentName: "Nome del documento",
  asc: "Ascendente",
  desc: "Discendente",
  operator: "Operatore",
  receiverName :  "Nome destinatario",
  receiver: "Destinatario",
  extractedAt: "Estratto il",
  claimAge: "Età",
  claimAgeLegendTitle: "Età del sinistro vs media",
  claimAgeLegendBody:
    "Il colore indica il tempo dall'estrazione rispetto alla media dei sinistri visibili. Verde = più recente, rosso = più vecchio.",
  claimAgeAvgBaseline: "Media della vista: {{age}}",
  claimAgeNewerThanAvg: "{{ratio}}× più giovane della media",
  claimAgeOlderThanAvg: "{{ratio}}× più vecchio della media",
  claimAgeAboutAvg: "Circa l'età media",
  claimAgeAverageMark: "Media",
  claimAgeTier_fresh: "Recente",
  claimAgeTier_typical: "Tipico",
  claimAgeTier_aging: "Invecchiato",
  claimAgeTier_stale: "In ritardo",
  lastModified: "Ultima modifica",
  noOfPages: "Numero di pagine",
  status: "Stato",
  action: "Azione",
  details: "Dettagli",
  generalInformation: "Informazioni generali",
  medicine_info: "Informazioni sui medicinali",
  invoice: "Fattura",
  invoiceDate: "Data della fattura",
  invoiceReference: "Riferimento della fattura",
  vetName: "Nome del veterinario",
  vetStreet: "Via veterinaria",
  city: "Città",
  postalCode: "Codice Postale",
  language: "Lingua",
  policyholderName: "Nome dell'assicurato",
  policyholderAddress: "Indirizzo del contraente",
  treatment: "Trattamento",
  treatmentDate: "Data del trattamento",
  diagnosis: "Diagnosi",
  itemName: "Nome dell'articolo",
  quantity: "Quantità",
  prize: "Prezzo",
  VAT: "IVA",
  addTreatment: "Aggiungi il trattamento",
  addItem: "Aggiungi articolo",
  total: "Totale",
  subTotal: "Subtotale",
  calculatedSum: "Totale dopo lo sconto",
  notes: "Appunti",
  page: "Pagina",
  pages: "Pagine",
  min: "min",
  mins: " mins",
  hour: " ora",
  hours: " ore",
  day: " giorno",
  days: " giorni",
  month: " mese",
  months: " mesi",
  ago: "fa",
  timeAgoPhrase: "{{count}} {{unit}} fa",
  modifiedBy: "Modificato da",
  modifiedAt: "Modificato il",
  clickASC: "Fare clic per ordinare in modo crescente",
  clickDESC: "Fare clic per ordinare in modo decrescente",
  petName: "Nome dell'animale",
  items: "Articoli",
  treatmentName: "Nome del trattamento",
  InvoiceTotalSumPriceWithoutVAT: "Importo totale della fattura IVA esclusa",
  InvoiceTotalSumPriceWithVAT: "Importo totale della fattura con IVA",
  CalculatedTotalSum: "Totale calcolato",
  TotalDiscountAmount: "Importo totale dello sconto",
  CalculatedTotalSumAfterDiscount: "Totale calcolato dopo lo sconto",
  recent: "Più recente",
  viewHistory: "Visualizza cronologia",
  remember: "Non chiedetelo più oggi",
  rememberSentance : "Oggi non vi chiederemo più un codice di verifica sul vostro dispositivo di fiducia al momento dell'accesso.",
  Complete_login : "Completa l'accesso",
  date: "Data",
  time: "Ora",
  note: "Nota",
  comment : "Commenti",
  revoke: "Revoca",
  deleteTreatment:"Elimina trattamento",
  deleteItem:"Elimina articolo",
  lastUpdate:"Ultimo aggiornamento",
  board:"Griglia",
  table:"Elenco",
  modified:"Modificato da",
  showing:"Mostra",
  totalSum:"Somma totale",
  of: "di",
  none: "Nessuno",
  customVAT: "IVA personalizzata",
  quality_level: "Livello di qualità",
  good: "Buono",
  verify: "Da verificare",
  not_extracted: "Non estratto",
  apply: "Applica",
  kpiTotal: "Totale",
  kpiNotStarted: "Non iniziato",
  kpiInProgress: "In corso",
  kpiCompleted: "Completato",
  kpiNeedsVerification: "Da verificare",
  kpiFailed: "Fallito",
  archive: "Archivia",
  reprocess: "Rielabora",
  archiveConfirmTitle: "Archivia documento",
  archiveConfirmContent: "Archiviare questo documento? Sparirà dalla coda ma resterà nello storico.",
  reprocessConfirmTitle: "Rielabora documento",
  reprocessConfirmContent: "Reinviare questo documento all'estrazione? I dati attuali saranno sostituiti.",
  failureReason: "Motivo del fallimento",
  receivedFrom: "Ricevuto da",
  receivedAt: "Ricevuto il",
  documentPreview: "Anteprima documento",
  failure_invalid_file_format: "Formato file non valido — il file non ha potuto essere letto.",
  failure_invalid_pet_invoice: "Fattura veterinaria non valida — nessun dato di fattura rilevato.",
  failure_extraction_issue: "Errore di estrazione — l'elaborazione è fallita inaspettatamente.",
  documentArchived: "Documento archiviato",
  documentReprocessing: "Documento inviato per la rielaborazione",
  archiveError: "Impossibile archiviare il documento",
  reprocessError: "Impossibile rielaborare il documento",
  countsError: "Impossibile caricare i contatori",
  viewDetails: "Vedi dettagli",
  dateFrom: "Da",
  dateTo: "A",
  dateRange: "Intervallo di date",
  searchPlaceholderExtended: "Cerca file, assicurato, veterinario, n. fattura",
  noteBy: "da",
  addNote: "Aggiungi nota",
  writeNote: "Scrivi una nota...",
  notesLog: "Note",
  duplicateWarning: "Possibile duplicato: un altro documento ha lo stesso riferimento fattura e lo stesso assicurato.",
  checkingDuplicate: "Controllo dei duplicati...",
  fieldsNeedAttention: "campi richiedono attenzione",
  allFieldsComplete: "Tutti i campi completi",
  vatBreakdown: "Ripartizione IVA",
  vatRate: "Aliquota IVA",
  netAmount: "Netto",
  vatAmount: "IVA",
  grossAmount: "Lordo",
  totalsMatch: "La somma calcolata corrisponde al totale della fattura",
  totalsDelta: "Differenza rispetto al totale della fattura",
  undoMyEdits: "Annulla le mie modifiche",
  restoreOriginal: "Ripristina estrazione originale",
  undoMyEditsContent: "Eliminare tutte le modifiche non salvate su questo documento?",
  restoreOriginalContent: "Ripristinare l'estrazione originale dal server? Tutte le tue modifiche andranno perse.",
  moveToTreatment: "Sposta nel trattamento",
  duplicateItem: "Duplica voce",
  moveUp: "Sposta su",
  moveDown: "Sposta giù",
  quantityTimesPrice: "Qtà × Prezzo",
  fullscreen: "Schermo intero",
  exitFullscreen: "Esci da schermo intero",
  thumbnails: "Miniature",
  pageOf: "di",
  invalidPostalCode: "Inserire un codice postale valido (4 cifre)",
  overrideAuto: "Sostituisci il valore calcolato automaticamente con un inserimento manuale",
  discountAppliedAfterSubtotal: "Applicato dopo il subtotale",
  verificationCompare: "Verifica: somma precedente {{legacy}} vs somma basata sulla quantità {{quantityAware}}",
  jumpToNextAttention: "Vai al campo successivo che richiede attenzione (Alt+N)",
  moreActions: "Altre azioni"
};

const commonEvents = {
  add: "Aggiungi",
  update: "Aggiorna",
  save: "Salva",
  cancel: "Annulla",
  reset: "Reimposta",
  download: "Scarica",
  clear: "Cancella",
  delete: "Elimina",
  assign: "Assegna",
  back: "Indietro",
  resetInitial: "Ripristina lo stato iniziale",
  enter_notes: "Inserisci qui le tue note...",
  Updated : "Aggiornato",
  Exported : "Esportato",
  Revoked: "Revocato",
  Assigned: "Assegnato",
  medicineDescription: "Descrizione del medicinale",
  purpose: "Scopo",
  usedFor: "Usato per",
  petTypes: "Tipi di animali",
  activeIngredients: "Ingredienti attivi",
  category: "Categoria",
  aiCategory: "Categoria IA",
  exclusionSubcode: "Sottocodice di esclusione",
  reasoning: "Motivazione della categoria",
  detection_keywords: "Parole chiave rilevate",
  translateReasonings: "Traduci le motivazioni",
  translateReasoningsSuccess: "Motivazioni tradotte",
  translateReasoningsEmpty: "Nessuna motivazione da tradurre",
  translateReasoningsTo: "Traduci in {{language}}",
  unclassified: "Non classificato",
  reasonForChange: "Motivo della modifica",
  reasonForChangePlaceholder: "Seleziona un motivo",
  changeContext: "Contesto aggiuntivo",
  changeContextPlaceholder: "Aggiungi piu dettagli sul motivo dell'aggiornamento della classificazione",
  showMore: "Mostra di piu",
  showLess: "Mostra meno",
  typeOfDamage: "Tipo di danno",
  causeOfDamage: "Causa del danno",
  loading: "Caricamento...",
  confidenceHigh: "Alta affidabilità",
  confidenceMedium: "Media affidabilità",
  confidenceLow: "Bassa affidabilità",
  feedbackReasonDiagnosis: "Diagnosi",
  feedbackReasonTreatmentContext: "Contesto del trattamento",
  feedbackReasonItemTextOrOcr: "Testo della riga o OCR",
  feedbackReasonExclusionRule: "Regola di esclusione",
  feedbackReasonInvoiceContext: "Contesto della fattura",
  feedbackReasonDuplicateOrWrongLine: "Riga duplicata o errata",
  feedbackReasonExpertJudgment: "Giudizio esperto",
  feedbackReasonOther: "Altro",
  required: "obbligatorio",
  feedbackOriginal: "Classificazione IA originale",
  feedbackCorrected: "Classificazione corretta",
  feedbackStatusDraft: "Correzione della classificazione non salvata",
  feedbackStatusPending: "Salvataggio del feedback di classificazione…",
  feedbackStatusSaved: "Feedback di classificazione salvato",
  feedbackStatusError: "Feedback di classificazione non riuscito",
  feedbackValidationTitle: "Il feedback di classificazione richiede attenzione",
  feedbackValidationDescription: "Correggi i campi evidenziati prima di salvare.",
  feedbackReasonRequired: "Seleziona un motivo per questa correzione.",
  feedbackContextRequired: "Aggiungi un contesto quando il motivo è Altro.",
  feedbackContextTooLong: "Il contesto deve contenere al massimo {{max}} caratteri.",
  feedbackExclusionSubcodeRequired: "Seleziona un sottocodice di esclusione valido.",
  feedbackNonExclusionSubcode: "I sottocodici di esclusione sono validi solo per la categoria E.",
  invalidCategory: "Seleziona una categoria valida.",
  feedbackSaveFailed: "Il feedback di classificazione non è stato salvato",
  feedbackConflict: "Questa correzione è già stata inviata o è in conflitto con una correzione più recente.",
  feedbackStale: "La previsione IA è cambiata. Ricarica il documento prima di correggerla.",
  feedbackNetworkError: "Impossibile salvare la correzione. La bozza è stata conservata.",
  feedbackUnavailableLegacy: "Questa categoria IA non può essere corretta perché non è stata salvata per l'apprendimento. Ricarica il documento, oppure rielaboralo se resta bloccata.",
  feedbackUnavailableRetrying: "La categoria IA è ancora in fase di salvataggio. Ricarica il documento tra pochi minuti per correggerla.",
  feedbackUnavailableNotStored: "Questa categoria IA non può essere corretta perché non è stata salvata nel registro di apprendimento. Rielabora il documento.",
  feedbackUnavailableDisabled: "Le correzioni di categoria non sono attive in questo ambiente. La categoria resta visibile ma non può essere salvata.",
  feedbackIdentityRequired: "Impossibile salvare la correzione perché manca l'identificativo della riga o della previsione IA. Ricarica o rielabora il documento.",
  feedbackDuplicateItemId: "Questo documento contiene più volte lo stesso identificativo di riga. Il salvataggio è bloccato; ricarica o rielabora il documento.",
  cat_T: "Trattamento medico",
  cat_D: "Decesso / Invalidità",
  cat_QS: "Screening preventivo",
  cat_QP: "Profilassi",
  cat_C: "Terapia complementare",
  cat_V: "Vaccinazione",
  cat_Dx: "Diagnostica avanzata",
  cat_G: "Alimenti dietetici",
  cat_H: "Sedute terapeutiche",
  cat_J: "Terapia comportamentale",
  cat_W: "Ospedalizzazione",
  cat_X: "Bonus trattenuto",
  cat_S: "Servizi di soccorso",
  cat_A: "Pagamento diretto",
  cat_R: "Rapporti veterinari",
  cat_E: "Esclusione",
  exc_g: "Costi di trasporto",
  exc_x: "Spese amministrative",
  exc_z: "IVA",
  exc_p: "Esami del passaporto",
  exc_q: "Costi del microchip",
  exc_i: "Cremazione / Incenerimento",
  exc_b: "Ferratura cavalli",
  exc_s: "Sterilizzazione elettiva",
  exc_c: "Costi di pensione",
  exc_m: "Cure non mediche",
  exc_d: "Esclusione cure dentali",
  exc_r: "Costi rapporti veterinari",
  operatorFallback: "Operatore Calingo"
};

const documentStatus = {
  not_yet_started: "Non iniziato",
  in_progress: "In corso",
  completed: "Completato",
};

const confirmationMessage = {
  deleteConfirmationTitle: "Conferma",
  deleteActionTreatmentContent:
    "Sei sicuro di voler eliminare questo trattamento? Questa azione non può essere annullata.",
  deleteActionItemContent:
    "Sei sicuro di voler eliminare questo elemento? Questa azione non può essere annullata.",
  resetConfirmationTitle: "Conferma",
  resetToInitialConfirmationTitle: "Ripristino della conferma iniziale",
  resetActionContent:
    "Sei sicuro di voler reimpostare i dati? Questa azione non può essere annullata.",
  resetInitialActionContent:
    "Sei sicuro di voler ripristinare lo stato iniziale? Questa azione non può essere annullata.",
  assignmentConfirmation:
    "Sei sicuro di volerti assegnare questo documento?",
  revokeConfirmation: "Sei sicuro di voler revocare l'assegnazione di questo documento?",
  reAssignConfirmation:
    "Sei sicuro di volerti riassegnare questo documento?",
  assignedTo: "Questo documento è assegnato a",
};

const errorNotification = {
  invalidEmail: "Inserisci un indirizzo e-mail valido!",
  emailEmpty: "Inserite il vostro indirizzo e-mail!",
  passwordEmpty: "Inserisci la password!",
  notAllowedToEdit: "Questo documento non può essere modificato",
  noteNotSaved: "Note non salvate",
  tokenExpired: "La sessione è scaduta, accedi di nuovo",
  accessDenied: "Accesso negato",
  notAssigned: "Assegnare il documento per accedere",
  documentListError: "Impossibile caricare l'elenco dei documenti",
  genericError: "Si è verificato un errore",
};

const successNotification = {
  DocumentResetToInitial : "Il documento è stato ripristinato allo stato iniziale",
  UpdateSuccess: "Aggiornato con successo",
  noteSaved: "Note salvate correttamente",
  successDocumentProgressStatus: "Assegnazione riuscita",
  revokeDocument: "Assegnazione revocata",
};

const batch1Ux = {
  saveAndNext: "Salva & avanti",
  complete: "Completa",
  completeAndDownload: "Completa & scarica",
  completeConfirmTitle: "Completa documento",
  completeConfirmContent: "Il documento verrà contrassegnato come completato. Continuare?",
  startProcessing: "Avvia lavorazione",
  takeOver: "Prendi in carico",
  readOnlyAssignedTo: "Sola lettura — questo documento è assegnato a {{name}}",
  readOnlyNotAssigned: "Questo documento non è ancora assegnato — assegnatelo per iniziare",
  savedAt: "Salvato alle {{time}}",
  unsavedChanges: "Modifiche non salvate",
  unsavedChangesTitle: "Modifiche non salvate",
  unsavedChangesContent: "Hai correzioni non salvate. Uscire senza salvare?",
  restore: "Ripristina",
  discard: "Scarta",
  restoreDraftTitle: "Ripristinare la bozza non salvata?",
  restoreDraftContent: "Per questo documento è stata trovata una bozza locale delle tue correzioni non salvate.",
  leave: "Esci",
  stay: "Rimani",
  queueEmpty: "Coda vuota — nessun'altra fattura da elaborare",
  markedCompleted: "Documento contrassegnato come completato",
  moreActions: "Altro",
  lastUpdated: "Ultimo aggiornamento {{time}}",
  mine: "miei",
  failed: "Non riuscito",
  completedToday: "Completati oggi",
  clearAllFilters: "Cancella tutti i filtri",
  selectedCount: "{{count}} selezionati",
  assignToMe: "Assegna a me",
  markCompleted: "Segna completato",
  exportSelected: "Esporta selezione",
  bulkAssignDone: "{{count}} assegnati a te, {{skipped}} saltati",
  bulkCompleteDone: "{{completed}} completati, {{skipped}} saltati",
  bulkExportDone: "{{count}} documenti scaricati",
  notAllowedToEditReason: "Il documento non ha potuto essere estratto (file non valido o contenuto illeggibile), quindi non c'è nulla da correggere.",
  totalsMatch: "Totale calcolato CHF {{calculated}} corrisponde al totale fattura CHF {{total}}",
  totalsDelta: "Calcolato CHF {{calculated}} · totale fattura CHF {{total}} · differenza CHF {{diff}}",
  previewDocument: "Anteprima del documento",
  previewNotAvailable: "Nessuna anteprima disponibile per questo documento.",
  openedAt: "Ultima apertura {{time}}",
  recentlyModified: "Modificati di recente",
  recentlyOpened: "Aperti di recente",
  recentlyExtracted: "Estratti di recente",
  noRecentDocuments: "Nessun documento recente",
  chooseAvatar: "Scegli avatar animale",
  chooseAvatarHint: "Scegli un animale. Ogni animale può essere usato da un solo operatore.",
  avatarLoadError: "Impossibile caricare gli avatar",
  avatarSaveSuccess: "Avatar animale salvato",
  avatarSaveError: "Impossibile salvare l'avatar",
  avatarTaken: "Questo animale è già preso",
  avatarTakenBy: "Preso da {{name}}",
  animalAvatar_dog: "Cane",
  animalAvatar_cat: "Gatto",
  animalAvatar_fox: "Volpe",
  animalAvatar_owl: "Gufo",
  animalAvatar_bear: "Orso",
  animalAvatar_rabbit: "Coniglio",
  animalAvatar_panda: "Panda",
  animalAvatar_lion: "Leone",
  animalAvatar_tiger: "Tigre",
  animalAvatar_wolf: "Lupo",
  animalAvatar_deer: "Cervo",
  animalAvatar_hedgehog: "Riccio",
  animalAvatar_koala: "Koala",
  animalAvatar_penguin: "Pinguino",
  animalAvatar_otter: "Lontra",
  animalAvatar_squirrel: "Scoiattolo",
  animalAvatar_eagle: "Aquila",
  animalAvatar_dolphin: "Delfino",
  animalAvatar_horse: "Cavallo",
  animalAvatar_frog: "Rana",
  reSubmitted: "Reinviato",
  uploadInvoice: "Carica fattura",
  invoiceFile: "File della fattura",
  selectInvoiceFile: "Fai clic o trascina qui una fattura",
  supportedInvoiceFiles: "JPG, JPEG, PNG, PDF o HEIC · max. 14 MiB",
  inboxType: "Tipo di casella",
  description: "Descrizione",
  invoiceFileRequired: "Seleziona un file di fattura",
  invoiceFileTypeError: "Usa un file JPG, JPEG, PNG, PDF o HEIC",
  invoiceFileSizeError: "Il file non deve superare 14 MiB",
  invoiceUploadSuccess: "Fattura caricata",
  invoiceUploadError: "Impossibile caricare la fattura",
};

const authManagement = {
  inviteOnlySignup: "Gli account sono disponibili solo su invito.",
  invalidInvitation: "Questo invito non è valido, è scaduto o è già stato usato.",
  acceptInvitation: "Accetta invito",
  name: "Nome",
  confirmPassword: "Conferma password",
  passwordsDoNotMatch: "Le password non coincidono",
  invitationAccepted: "Invito accettato. Accedi per configurare l’MFA.",
  backToLogin: "Torna al login",
  forgotPasswordInstructions: "Inserisci l’e-mail per ricevere un codice.",
  passwordResetEmailSent: "Se l’account esiste, è stato inviato un codice.",
  sendCode: "Invia codice",
  verifyCode: "Verifica codice",
  invalidOrExpiredCode: "Il codice non è valido o è scaduto.",
  resendUnavailable: "Non è ancora possibile inviare un nuovo codice.",
  resetPassword: "Reimposta password",
  invalidResetLink: "La reimpostazione non è valida o è scaduta.",
  passwordPolicy: "Almeno 12 caratteri con maiuscola, minuscola, numero e simbolo.",
  passwordResetComplete: "Password reimpostata.",
  mfaRecovery: "Recupero MFA",
  recoveryCodeSent: "Un codice di recupero è stato inviato a {{email}}.",
  recoveryMustStartAtLogin: "Avvia il recupero dalla schermata MFA.",
  waitingForAdminApproval: "E-mail verificata. In attesa dell’approvazione amministratore.",
  refreshStatus: "Aggiorna stato",
  recoveryRejected: "La richiesta di recupero è stata rifiutata.",
  setupNewAuthenticator: "Configura un nuovo autenticatore",
  usersAndInvitations: "Utenti e inviti",
  inviteUser: "Invita utente",
  inviteLanguage: "Lingua dell'invito",
  inviteLanguageHint: "Lingua usata per l'e-mail di invito.",
  langGerman: "Tedesco",
  langEnglish: "Inglese",
  langFrench: "Francese",
  langItalian: "Italiano",
  used: "Licenze usate",
  licensed: "Licenze disponibili nel contratto",
  available: "Licenze libere",
  users: "Utenti",
  invitations: "Inviti",
  role: "Ruolo",
  status: "Stato",
  actions: "Azioni",
  promote: "Promuovi",
  demote: "Declassa",
  activate: "Attiva",
  deactivate: "Disattiva",
  deliveryStatus: "Consegna",
  expiresAt: "Scadenza",
  requestedAt: "Richiesto",
  resend: "Reinvia",
  revoke: "Revoca",
  resendInvitation: "Reinvia invito",
  revokeInvitation: "Revoca invito",
  approve: "Approva",
  reject: "Rifiuta",
  approveRecovery: "Approva recupero MFA",
  rejectRecovery: "Rifiuta recupero MFA",
  confirmAdminAction: "Conferma l’azione con la password",
  confirmWithPassword: "Password amministratore",
};

export const itJSON = {
  ...commonEvents,
  ...loginComponent,
  ...dashboardComponent,
  ...errorNotification,
  ...commonTranslation,
  ...documentStatus,
  ...confirmationMessage,
  ...successNotification,
  ...batch1Ux,
  ...authManagement
};
